import React, { Fragment, useEffect, useState } from "react";
import { Flex } from "theme-ui";
import Carousel from "./Carousel";
import Overall from "./Overall";
import sal from "sal.js";
import { graphql, useStaticQuery } from "gatsby";

interface TrustPilotProps extends CarouselProps {}

export interface OverallProps {
  numberOfReviews: {
    usedForTrustScoreCalculation: number;
    total: number;
  };
  score: {
    stars: number;
    trustScore: number;
  };
  rating: number;
  total: number;
  level: string;
  size?: number | string;
}
export interface CarouselProps {
  reviews?: ReviewProps[] | null;
  autoPlay?: boolean;
  timing?: number;
  header?: string;
}
export interface ReviewProps {
  stars: number;
  reviewVerificationLevel: string;
  title: string;
  text: string;
  id: string;
  consumer: {
    displayName: string;
  };
  createdAt: string;
}

const TrustPilot = (props: TrustPilotProps) => {
  const { header } = props;
  const [reviews, setReviews] = useState<null | any>(null);

  const data = useStaticQuery(graphql`
    query {
      allTrustPilotReviewTotal {
        edges {
          node {
            score {
              stars
              trustScore
            }
            displayName
            numberOfReviews {
              total
              usedForTrustScoreCalculation
            }
          }
        }
      }
      allTrustPilotAllReviews {
        edges {
          node {
            reviews {
              numberOfLikes
              stars
              text
              title
              createdAt
              isVerified
              reviewVerificationLevel
              consumer {
                displayName
              }
            }
          }
        }
      }
    }
  `);
  const { allTrustPilotReviewTotal, allTrustPilotAllReviews } = data;

  useEffect(() => {
    sal();
  }, [data]);

  return (
    <section
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Flex
        sx={{
          minHeight: "375px",
          maxWidth: "1165px",
          width: "100%",
          minWidth: "375px",
          alignItems: "center",
          justifyContent: "space-evenly",
          flexDirection: "column",
          bg: "white",
          borderRadius: "4px",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.10)",
        }}
      >
        {/* <h3
          sx={{
            variant: "text.h3",
            color: "black",
            my: ["30px", null, null, null],
          }}
        >
          {header ? header : "Satisfied Customers"}
        </h3> */}
        {data && (
          <Flex
            data-sal="slide-up"
            data-sal-delay={0}
            data-sal-duration="1000"
            data-sal-easing="easeOutQuart"
            sx={{
              justifyContent: "space-between",
              alignItems: ["center", null, null, "flex-start"],
              flexDirection: ["column", "row", "row", "row", "row"],
              maxWidth: "1165px",
              width: "100%",
            }}
          >
            <Overall
              {...allTrustPilotReviewTotal.edges[0].node}
              level="Excellent"
            />
            <Carousel
              {...props}
              reviews={allTrustPilotAllReviews.edges[0].node.reviews}
            />
          </Flex>
        )}
      </Flex>
    </section>
  );
};

export default TrustPilot;
